import { TitleAndTable } from "components/Common"
import { ModuleIds } from "constant"
import {
    selectCheckboxHandler
} from "helpers/utilities"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { getErrorLog, updateErrorLog } from "store/actions"
import ErrorLogTable from "./ErrorLogTable"
import ErrorLogModal from "./ErrorLogModal"
import { exportErrorLog } from "helpers/app-backend/testResult_backend_helper"
import moment from "moment"

const RESOURCE = ModuleIds.Logs

const ErrorLog = ({
    onGetErrorLog,
    errorLog,
    t,
    paging,
    loadingErrorLog,
    errorLogTime,
    onUpdateErrorLog
}) => {
    const [row, setRow] = useState({})
    const [modal, setModal] = useState(false)
    const [rows, setRows] = useState([])
    const [model, setModel] = useState({
        search: '',
        page: 1,
        size: 10,
        start: new Date().setDate(new Date().getDate() - 1),
        end: new Date()
    })

    useEffect(() => {
        onGetErrorLog(model)
    }, [])

    const toggle = () => {
        setModal(prev => !prev)
    }

    const onSelectCheckbox = (row, isSelected) => {
        const { rowsState, currentRow } = selectCheckboxHandler(
            rows,
            row,
            isSelected
        )
        setRows(rowsState)
        setRow(currentRow)
    }

    const onSelectAllCheckbox = rows => {
        setRows(rows)
        if (rows.length < 1) setRow({})
        else setRow(rows[rows.length - 1])
    }

    const onSubmitFilter = (values) => {
        setModel({ ...model, ...values })
        onGetErrorLog({ ...values, page: 1, size: 10 })
    }

    const onSearch = (searchText) => {
        let val = {
            search: searchText || ''
        }
        setModel({ ...model, ...val })
        onGetErrorLog({ ...model,...val, page: 1, size: 10 })
    }

    const onSizePerPageChange = size => {
        onGetErrorLog({ ...model, page: 1, size })
        setModel({ ...model, page: 1, size })
    }

    const onPageChange = page => {
        onGetErrorLog({ ...model, page })
        setModel({ ...model, page })
    }

    const onRefreshHandler = () => {
        onGetErrorLog({ ...model, search: '', page: 1, size: 10 })
        setModel({ ...model, search: '', page: 1, size: 10 })
    }

    const onSortHandler = (field, order) => {
        const sortString = `${field}:${order}`
        onGetErrorLog({ ...model, search: model.search, page: 1, size: 10, sort: sortString })
    }

    const onSolveChange = (data) => {
        onUpdateErrorLog(data)
    }

    const onRowClick = (e, data) => {
        setRow(data)
        toggle()
    }

    const onDownloadFile = async () => {
        let payload = { ...model, search: model.search, page: 1, size: 10 }
        payload.startDate = moment(payload.start).format("YYYY-MM-DD HH:mm")
        payload.endDate = moment(payload.end).format("YYYY-MM-DD HH:mm")
        await exportErrorLog(payload);
    }
    return (
        <React.Fragment>
            <TitleAndTable
                resource={RESOURCE}
                table={() => (
                    <ErrorLogTable
                        errorLog={errorLog}
                        onSelect={onSelectCheckbox}
                        onSelectAll={onSelectAllCheckbox}
                        onSearch={onSearch}
                        onRefresh={onRefreshHandler}
                        onPageChange={onPageChange}
                        paging={paging}
                        onSort={onSortHandler}
                        onSizePerPageChange={onSizePerPageChange}
                        onSubmitFilter={onSubmitFilter}
                        onSolveChange={onSolveChange}
                        loading={loadingErrorLog}
                        updatedTime={errorLogTime}
                        onRowClick={onRowClick}
                        onDownloadFile={onDownloadFile}
                        onChangeModel={val => {
                            setModel({ ...model, ...val })
                        }}
                    />
                )}
                external
                subtitle={t("")}
                icon={false}
            />
            <ErrorLogModal
                modal={modal}
                toggle={toggle}
                data={row}
            />
        </React.Fragment>
    )
}

ErrorLog.propTypes = {
    onGetErrorLog: PropTypes.func,
    t: PropTypes.any,
    paging: PropTypes.any,
    errorLog: PropTypes.any
}

const mapStateToProps = ({ auditLog }) => ({
    errorLog: auditLog.errorLog.errorLog,
    paging: auditLog.errorLog.paging,
    loadingErrorLog: auditLog.errorLog.loadingErrorLog,
    errorLogTime: auditLog.errorLog.errorLogTime,
})

const mapDispatchToProps = dispatch => ({
    onGetErrorLog: payload => dispatch(getErrorLog(payload)),
    onUpdateErrorLog: payload => dispatch(updateErrorLog(payload)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation(["message", "common", "hisConnectorPage"])(ErrorLog))